type CustomerInfo = {
  name?: string;
  surname?: string;
  phone?: string;
  email?: string;
  id?: string;
};

interface MetadataState {
  customerInfo: any;
}

export const customerInfoStorageKey = "metadata.customer_info";

export const metadataModule = {
  namespaced: true,
  state: (): MetadataState => ({
    customerInfo: null
  }),
  mutations: {
    SET_CUSTOMER_INFO(
      state: MetadataState,
      info: {
        name: string;
        phone: string;
        email?: string;
        id?: string;
      }
    ) {
      state.customerInfo = info;
    },
    UNSET_CUSTOMER_INFO(state: MetadataState) {
      state.customerInfo = null;
    }
  }
};
